

<template>
  <div class="mx-15" v-if="participant">
    <h2 class="text-left">{{participant.display_name}} Results</h2>
    <p class="c-text--italics text-left mt-5" v-if="vendor === 'trendmicro'">
      Although Trend Micro participated and completed testing for this inaugural round, after an unintended situation,
      Trend Micro promptly and responsibly shared that their team had found sensitive information to MITRE.
      Based on the agreement between MITRE and Trend Micro, MITRE did not publish Trend Micro’s
      results. Please contact Trend Micro directly for more information.
      </p>
    <p class="c-text--italics text-left mt-5" v-else>
      {{`Due to technical incompatibilities between the vendor's product and this round's emulation execution we were
      unable to successfully complete our evaluation within the allotted time frame, and therefore do not have
      results for this vendor. This is not a reflection of the product, as performance was not measured. We are
      working with the vendor to resolve the incompatibilities for the next round. Any publication mentioning
      ${participant.display_name} product's evaluation results for this round is therefore unofficial and
      inaccurate.`}}
    </p>
  </div>
</template>

<script setup>
import { defineProps, inject, ref, onMounted } from "vue";

const globalProperties = inject('globalProperties');

const participant = ref(undefined);

const props = defineProps({
  vendor: String
})

function getParticipant() {
  globalProperties.$api
    .get(`participants/?name=${props.vendor}`).then(response => {
      participant.value = response.data[0];
    })
}

onMounted(() => {
  getParticipant();
  window.scrollTo(0, 0)
})

</script>
